
import $ from "jquery"

import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

const onLoad = () => {
  requestIdleCallback(() => {
    // listener on .main-navbar-inner
    // as app/authentication/remote_state setAsSignedInAndRefreshComponents
    // will modify dom tree
    import(
      "app/authentication/action"
    )
    .then(({showSignUpModal}) => {
      $(".js-btn-sign-up").on("click", (e) => {
        e.stopPropagation()
        e.preventDefault()
        showSignUpModal().done()
      })
    })
  })
}

export {
  onLoad,
}
